import { useMemo, useState } from "react";
import useGetCurrentUserPermissionScope from "~hooks/useGetCurrentUserPermissionScope.ts";
import type { League } from "~types/league.ts";

type FilterValue = {
  value: string;
};

type Props = {
  regionTypeFilter?: FilterValue[];
  countryCodeFilter?: FilterValue[];
};

export const useFilteredLeagues = ({ regionTypeFilter, countryCodeFilter }: Props) => {
  const [searchText, setSearchText] = useState("");
  const { data: scopeData, isLoading } = useGetCurrentUserPermissionScope();
  const { scope, resources } = scopeData || {};

  const allLeagues: League[] = useMemo(() => {
    const leaguesData = resources?.leagues || {};

    return (scope?.leagueTree || [])
      .filter(({ leagueId }) => leagueId && leagueId in leaguesData)
      .map(({ leagueId }) => ({ ...leaguesData[leagueId as string] }));
  }, [scope?.leagueTree, resources?.leagues]);

  const filteredLeagues = useMemo(() => {
    let result = allLeagues;

    if (searchText) {
      const lowerSearch = searchText.toLowerCase();
      result = result.filter(({ nameLocal }) => nameLocal?.toLowerCase().includes(lowerSearch));
    }

    if (Array.isArray(regionTypeFilter) && regionTypeFilter.length > 0) {
      const selectedValues = regionTypeFilter.map((item) => item.value);
      result = result.filter(({ regionType }) => selectedValues.includes(regionType));
    }
    if (Array.isArray(countryCodeFilter) && countryCodeFilter.length > 0) {
      const selectedValues = countryCodeFilter.map((item) => item.value);
      result = result.filter(({ countryCode }) => countryCode && selectedValues.includes(countryCode));
    }

    return result;
  }, [allLeagues, searchText, regionTypeFilter, countryCodeFilter]);

  return {
    filteredLeagues,
    isLoading,
    searchText,
    setSearchText,
  };
};
